// Copyright 2025. WebPros International GmbH. All rights reserved.

import * as React from 'react';
import { Translate } from '@plesk/ui-library';
import {
    Header,
    Title,
    Action,
} from 'client/common/components/PageSubHeader/Styles';

export interface IPageSubHeaderProps {
    id?: string;
    title: string;
    action?: JSX.Element;
}

export const PageSubHeader: React.FC<IPageSubHeaderProps> = ({
    id,
    title,
    action,
}) => (
    <Header id={id}>
        <Title>
            <Translate content={title} />
        </Title>
        {action && (
            <Action>
                {action}
            </Action>
        )}
    </Header>
);
